import { Id } from '@softline/core';

export interface FavoriteList<T> {
  key: string;
  favorites: Favorite<T>[];
}

export interface Favorite<T> {
  id: Id;
  object: T;
  timestamp: string;
}
